// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rsLabelData .rsLabel.h2{margin-bottom:10px}
`, "",{"version":3,"sources":["webpack://./src/components/labelData/LabelData.scss"],"names":[],"mappings":"AACA,yBAGG,kBAAmB","sourcesContent":["@import '../../themes/themes';\n.rsLabelData {\n\t.rsLabel {\n\t\t&.h2 {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
